const ACTION_TYPE = "EKONT";
export const GET_CITIES = `${ACTION_TYPE}/GET_CITIES`;
export const GET_OFFICES = `${ACTION_TYPE}/GET_OFFICES`;
